import { imageBaseUrl } from "../../assets/backend";
import React from "react";

const Picture = ({book, classname}) => {
    return (
        <img
            src={`${imageBaseUrl}/${book.picture}`}
            alt={`${book.title} cover`}
            className={classname}
        />
    );
}

export default Picture;